import { falCommentLines } from 'shared/@generated/icons/falCommentLines';
import { falGrid2 } from 'shared/@generated/icons/falGrid2';
import { falImageStack } from 'shared/@generated/icons/falImageStack';
import { falMagnifyingGlass } from 'shared/@generated/icons/falMagnifyingGlass';
import { falUserCircle } from 'shared/@generated/icons/falUserCircle';
import { fasComment } from 'shared/@generated/icons/fasComment';
import { fasGrid2 } from 'shared/@generated/icons/fasGrid2';
import { fasImageStack } from 'shared/@generated/icons/fasImageStack';
import { fasMagnifyingGlass } from 'shared/@generated/icons/fasMagnifyingGlass';
import { fasUserCircle } from 'shared/@generated/icons/fasUserCircle';
import { TouchableOpacity, View } from 'react-native';
import { FaIcon, Icon } from 'shared/components/icon';
import { useRouter } from 'shared/library/use-router';
import { Text } from 'shared/components/text';
import { useIsLoggedIn } from 'shared/state/user';
import { UnreadCount } from 'shared/components/chat/unread-count';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteName, useIsCurrentRoute, useRoute } from 'shared/library/routes/route';

const Tabs = () => {
  const { t } = useTranslation('web');
  const isLoggedIn = useIsLoggedIn();
  const route = useRoute();

  return isLoggedIn ? (
    <View
      style={{ paddingBottom: 'var(--safe-bottom)' } as any}
      className={
        'border-brand-brown-dark/10 shadow-brand-brown-dark/5 bg-brand-cream-light shadow-tabs fixed bottom-0 left-0 right-0 z-50 w-full border-t md:hidden'
      }
    >
      <View className={'h-[var(--tabs-h)] flex-row'}>
        <Tab
          title={t('layout.menu.home')}
          routeName={'home'}
          href={route('home')}
          icon={falGrid2}
          activeIcon={fasGrid2}
        />
        <Tab
          title={t('layout.menu.browse')}
          routeName={'listings.index'}
          href={route('listings.index')}
          ignoreRouteNames={['listings.create']}
          icon={falMagnifyingGlass}
          activeIcon={fasMagnifyingGlass}
        />
        <Tab
          title={t('layout.menu.sell')}
          routeName={'me.listings.index'}
          href={route('me.listings.index')}
          activeRouteNames={[
            'listings.create',
            'me.listings.index',
            'me.listings.edit',
            'me.listings.create',
            'me.listings.verify',
            'me.listings.monitor',
            'me.listings.litter-insurance',
          ]}
          icon={falImageStack}
          activeIcon={fasImageStack}
        />
        <Tab
          title={t('layout.menu.inbox')}
          routeName={'me.inbox'}
          href={route('me.inbox')}
          icon={falCommentLines}
          activeIcon={fasComment}
        >
          <UnreadCount loadInitial={true} className={'absolute left-1/2 top-2 translate-x-1'} />
        </Tab>
        <Tab
          title={t('layout.menu.account')}
          routeName={'me.index'}
          href={route('me.index')}
          ignoreRouteNames={[
            'me.listings.index',
            'me.listings.edit',
            'me.listings.create',
            'me.listings.verify',
            'me.listings.monitor',
            'me.listings.litter-insurance',
          ]}
          icon={falUserCircle}
          activeIcon={fasUserCircle}
        />
      </View>
    </View>
  ) : null;
};

const Tab = ({
  title,
  routeName,
  href,
  activeRouteNames,
  ignoreRouteNames,
  icon,
  activeIcon,
  children,
}: {
  title: string;
  routeName: RouteName;
  href: string;
  activeRouteNames?: RouteName[];
  ignoreRouteNames?: RouteName[];
  icon: FaIcon;
  activeIcon: FaIcon;
  children?: ReactNode;
}) => {
  const { push } = useRouter();
  const isCurrentRoute = useIsCurrentRoute();

  const isAnyActiveRoute = activeRouteNames?.some((name) => isCurrentRoute(name)) ?? false;
  const isAnyIgnoredRoute = ignoreRouteNames?.some((name) => isCurrentRoute(name)) ?? false;

  const isActive = (isAnyActiveRoute || isCurrentRoute(routeName)) && !isAnyIgnoredRoute;

  return (
    <TouchableOpacity className={'w-1/5'} onPress={() => push(href)}>
      <View className={'items-center p-3'}>
        <Icon
          icon={isActive ? activeIcon : icon}
          className={isActive ? 'text-brand-brown-dark' : 'text-brand-brown-dark/80'}
        />
        <Text
          className={`${isActive ? 'text-brand-brown-dark' : 'text-brand-brown-dark/80'} text-2xs mt-1`}
        >
          {title}
        </Text>
        {children}
      </View>
    </TouchableOpacity>
  );
};

export { Tabs };
